import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLoading } from '../global';
import axios from 'axios';
import { bearerAuth } from '../auth';


export const startPresentationExchange = createAsyncThunk(
    'genericRequest/startPresentationExchange', ({jwtToken, verifierTemplateKey, successUrl, walletUrl, frontendCorrelationKey}: { jwtToken: string | undefined, verifierTemplateKey: string, successUrl: string, walletUrl: string | undefined, frontendCorrelationKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        const body = {
            successUrl,
            frontendCorrelationKey
        } as any;
        if (walletUrl !== undefined) {
            body.walletUrl = walletUrl;
        }
        return axios.post('/genericRequest/startCredentialExchange/' + verifierTemplateKey, body, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);


export const receiveCredentials = createAsyncThunk(
    'genericRequest/receiveCredentials', ({jwtToken, correlationId}: { jwtToken: string | undefined, correlationId: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.get('/genericRequest/statusCredentialExchange/' + correlationId, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);


